/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
// Global
import { useRef } from 'react';
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { useTab } from 'helpers/Context/TabContext';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const TabItem = (props)=>{
    const isEditing = useIsEditing();
    const { content } = props?.fields || {};
    const { uid } = props?.rendering || {};
    const TabId = `tab-content-${uid}`;
    const tabItemHeadlineRef = useRef(null);
    const { activeTab } = useTab();
    const isActive = props?.rendering?.uid === activeTab;
    const { base, contentWrapper } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _createElement("div", {
        "data-component": "authorable/shared/lists/Tabitem",
        ...editingHydrationProps(isEditing),
        className: base({
            isActive
        }),
        key: TabId,
        ref: tabItemHeadlineRef,
        id: TabId,
        role: "tabpanel",
        "aria-live": "polite",
        "aria-labelledby": `tab-${uid}`,
        ...getTestProps(`component-tab-item-${TabId}`)
    }, /*#__PURE__*/ _jsx("div", {
        className: contentWrapper(),
        children: /*#__PURE__*/ _jsx(RichTextWrapper, {
            field: content,
            ...getTestProps(`rich-text`)
        })
    }));
};
export const Default = withStandardComponentWrapper(TabItem);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [],
        contentWrapper: [
            'pt-margin-less',
            'pb-margin-base'
        ]
    },
    variants: {
        isActive: {
            true: {
                base: [
                    'visible'
                ]
            },
            false: {
                base: [
                    'hidden'
                ]
            }
        }
    }
});
